import { render, staticRenderFns } from "./LegalesForm.vue?vue&type=template&id=79fb03ac&"
import script from "./LegalesForm.vue?vue&type=script&lang=js&"
export * from "./LegalesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports